import { TherapistAction } from 'src/redux/actions/constant';

const intialState: object = {
  response: null,
  isTherapistTaskMigrated: false,
  data: [],
  loading: false,
  isError: false,
};

export const therapistMigrateTaskReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case TherapistAction.THERAPIST_TASK_MIGRATE_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isTherapistTaskMigrated: true,
        data: action.payload?.data || null,
        loading: false,
        isError: false,
      };
    }
    case TherapistAction.THERAPIST_TASK_MIGRATE_FAILURE: {
      return {
        ...state,
        response: action.payload,
        isTherapistTaskMigrated: false,
        loading: false,
        isError: true,
      };
    }
    case TherapistAction.THERAPIST_TASK_MIGRATE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case TherapistAction.THERAPIST_TASK_MIGRATE_RESET:
      return {
        ...state,
        response: null,
        isTherapistTaskMigrated: false,
        loading: false,
        isError: false,
      };

    default:
      return state;
  }
};
